// 登录页相关的 COLOR_KEY 配置
// 使用 semanticTokens 中已经定义好的语义色

// import {semantic} from './semantic-tokens';

export const loginConfig: { [key: string]: (string | object)[] } = {
  // 登录页
  // loginCardBg: [semantic.fillNeutral100, semantic.fillNeutral100],
  // loginTitleText:  [semantic.fillNeutral100, semantic.fillNeutral100],
  // loginSubtitleText:  [semantic.fillNeutral100, semantic.fillNeutral100],
  // loginFooterText:  [semantic.fillNeutral100, semantic.fillNeutral100],
};
